import { Component } from 'react'
import { Box, ProductInfoBox, Spacer, Button, KeyValueRow, ProductInfoBoxWam } from 'stylewhere/components'
import { T, __ } from 'stylewhere/shared/i18n'
import { TmrProduct, EncodingCounters, ProductInfoField } from 'stylewhere/api'

interface Props {
  product?: TmrProduct
  clear: any
  counters?: EncodingCounters
  fields?: ProductInfoField[]
  productClose?: any
  initialType?: string
  operationId?: string
  wam?: string
  disabledClear?: boolean
  flex?: boolean
}

export class EncodingProduct extends Component<Props> {
  render() {
    const { product, clear, counters, fields, productClose, initialType, operationId, wam, disabledClear, flex } =
      this.props
    return (
      <Box flex={flex !== undefined ? (flex ? 1 : 0) : true} justify={'space-between'}>
        <Box mb={10}>
          <ProductInfoBox
            product={product}
            fields={fields}
            onCloseClick={productClose}
            paddingCard={'20px 20px 20px 20px'}
          />
          <ProductInfoBoxWam initialType={initialType} wam={wam} operationId={operationId} />
          {counters && (
            <>
              <Spacer />
              <KeyValueRow>
                <KeyValueRow
                  variant="raw"
                  value={`${counters?.order.pending + counters?.order.encoded} / ${counters?.order.expected}`}
                  label={__(T.misc.item_order)}
                />
                <Box height={60} width={2} bgGrey />
                <KeyValueRow
                  variant="raw"
                  value={`${counters?.row.pending + counters?.row.encoded} / ${counters?.row.expected}`}
                  label={__(T.misc.item_row)}
                />
              </KeyValueRow>
              <Spacer />
            </>
          )}
        </Box>
        {!disabledClear && <Button variant="default" title={__(T.misc.clear)} onClick={clear} />}
      </Box>
    )
  }
}
